import { memo, useEffect } from 'react'

import { Anchor, Center, Loader, Stack, Text } from '@mantine/core'

import { useGetWalletRiskCheck } from '@repo/common/queries/wallet'

import type { BasePanelProps } from '@/flows/flow_helpers'

export const PanelCheckWalletRisk = memo<BasePanelProps>(
  function PanelCheckWalletRisk({ onCompleted }) {
    const wallet_risk = useGetWalletRiskCheck({ refetch_until_completed: true })

    useEffect(() => {
      if (wallet_risk.data?.passed) {
        onCompleted()
      }
    }, [onCompleted, wallet_risk.data?.passed])

    if (
      wallet_risk.data?.passed == false &&
      wallet_risk.data.status == 'completed'
    ) {
      return (
        <Stack gap="xs" miw="300px">
          <Text c="red" role="status">
            Wallet Failed Checks
          </Text>
          <Text>
            If you have any questions or issues please reach out to us at{' '}
            <Anchor href="mailto:hello@fission.xyz">hello@fission.xyz</Anchor>.
          </Text>
        </Stack>
      )
    }

    return (
      <Stack miw="300px">
        <Text>Checking wallet...</Text>
        <Center w="100%">
          <Loader color="primary" type="bars" />
        </Center>
      </Stack>
    )
  },
)

export const useSkipWalletRisk = (): boolean => {
  const wallet_risk = useGetWalletRiskCheck()

  return wallet_risk.data?.passed ?? false
}
